/* Rince mega-menu — geëxtraheerd uit sections/rince-mega-menu.liquid.
   Eén gedeeld, deferred module-script voor alle mega-menu-secties.
   Gesloten panelen krijgen `inert` zodat links erin geen tab-stops zijn. */
(function() {
  function initHxMega(section) {
    if (!section || section.dataset.hxMegaInit === '1') return;
    section.dataset.hxMegaInit = '1';
    if (section.classList.contains('hx-mega--editor-open')) return;

    var triggerLabel = (section.dataset.triggerLabel || '').toLowerCase().trim();
    if (!triggerLabel) return;

    if (section.parentNode !== document.body) document.body.appendChild(section);

    var panel = section.querySelector('.hx-mega-panel');
    var isOpen = false;
    var openTimer = null;
    var closeTimer = null;
    var lastFocused = null;
    var OPEN_DELAY = 120;
    var CLOSE_DELAY = 280;

    function isTouch() {
      return window.matchMedia('(hover: none), (pointer: coarse)').matches;
    }
    function isMobileWidth() { return window.innerWidth < 750; }

    function getHeaderBottom() {
      var header = document.querySelector('header-component, .header-section, .header, header');
      return header ? Math.round(header.getBoundingClientRect().bottom) + 'px' : '80px';
    }

    function currentTrigger() {
      var nodes = document.querySelectorAll(
        '.menu-list__link, .menu-list__item, .header__drawer a, .header__drawer button, nav a, nav button'
      );
      for (var i = 0; i < nodes.length; i++) {
        var t = (nodes[i].innerText || nodes[i].textContent || '').replace(/\s+/g, ' ').toLowerCase().trim();
        if (t === triggerLabel) return nodes[i];
      }
      return null;
    }

    function isTriggerEl(node) {
      if (!node || !node.closest) return false;
      var item = node.closest(
        '.menu-list__link, .menu-list__item, .menu-list__list-item a, .menu-list__list-item button, .header__drawer a, .header__drawer button, nav a, nav button'
      );
      if (!item) return false;
      var text = (item.innerText || item.textContent || '').replace(/\s+/g, ' ').toLowerCase().trim();
      return text === triggerLabel ? item : false;
    }

    function syncAria(expanded) {
      var trig = currentTrigger();
      if (trig) trig.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function lockScroll(lock) {
      if (lock && isMobileWidth()) {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      } else {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }
    }

    function focusableInPanel() {
      return section.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    }

    function openMenu() {
      if (isOpen) return;
      isOpen = true;
      lastFocused = document.activeElement;
      var top = getHeaderBottom();
      if (panel) panel.style.top = top;
      var overlay = section.querySelector('.hx-mega-overlay');
      if (overlay) overlay.style.top = top;
      section.classList.add('is-open');
      section.setAttribute('aria-hidden', 'false');
      section.removeAttribute('inert');
      syncAria(true);
      lockScroll(true);
      if (isTouch() || isMobileWidth()) {
        var firstBtn = section.querySelector('.hx-mega-close, .hx-mega-back');
        var first = firstBtn || focusableInPanel()[0];
        if (first) setTimeout(function(){ try { first.focus(); } catch (e) {} }, 60);
      }
    }

    function closeMenu(returnFocus) {
      if (!isOpen) return;
      isOpen = false;
      section.classList.remove('is-open');
      section.setAttribute('aria-hidden', 'true');
      section.setAttribute('inert', '');
      syncAria(false);
      lockScroll(false);
      if (returnFocus && lastFocused && lastFocused.focus) {
        try { lastFocused.focus(); } catch (e) {}
      }
    }

    // Sluit ook de onderliggende mobiele drawer van het theme (alleen op mobiel).
    function closeThemeDrawer() {
      if (!isMobileWidth()) return;
      // 1) Open <details>-drawers (Horizon gebruikt vaak een details/summary-drawer).
      document.querySelectorAll('details[open]').forEach(function(d) {
        if (d.querySelector('.header__drawer') || (d.id && d.id.indexOf('menu-drawer') !== -1) || d.closest('.header')) {
          d.removeAttribute('open');
        }
      });
      // 2) Dialog/modal-componenten (nieuwere Horizon-builds).
      document.querySelectorAll('dialog[open]').forEach(function(dlg) {
        if (dlg.closest('.header') || dlg.querySelector('.header__drawer')) {
          try { dlg.close(); } catch (e) {}
        }
      });
      // 3) Klik desnoods de officiële sluitknop van de drawer, als die er is.
      var themeClose = document.querySelector('.header__drawer [aria-label*="luit" i], .menu-drawer [aria-label*="lose" i], .header [data-close-drawer]');
      if (themeClose) { try { themeClose.click(); } catch (e) {} }
    }

    function scheduleOpen() { clearTimeout(closeTimer); clearTimeout(openTimer); openTimer = setTimeout(openMenu, OPEN_DELAY); }
    function scheduleClose() { clearTimeout(openTimer); clearTimeout(closeTimer); closeTimer = setTimeout(function(){ closeMenu(false); }, CLOSE_DELAY); }

    section.removeAttribute('hidden');
    section.setAttribute('aria-hidden', 'true');
      section.setAttribute('inert', '');
    section.setAttribute('role', 'dialog');
    section.setAttribute('aria-label', 'Navigatie: ' + triggerLabel);

    // ── HOVER (alleen op echte hover-apparaten) ──
    document.addEventListener('pointerover', function(e) {
      if (isTouch() || isMobileWidth()) return;
      if (isTriggerEl(e.target)) scheduleOpen();
    }, { passive: true });

    document.addEventListener('pointerout', function(e) {
      if (isTouch() || isMobileWidth()) return;
      var to = e.relatedTarget;
      var stay = isTriggerEl(to) || (to && section.contains(to));
      var leaving = isTriggerEl(e.target) || section.contains(e.target);
      if (leaving && !stay) scheduleClose();
    }, { passive: true });

    if (panel) {
      panel.addEventListener('pointerenter', function(){ clearTimeout(closeTimer); }, { passive: true });
      panel.addEventListener('pointerleave', function(){ if (!isMobileWidth()) scheduleClose(); }, { passive: true });
    }

    // ── KLIK / TAP (desktop én touch) ──
    document.addEventListener('click', function(e) {
      if (e.target.closest && e.target.closest('[data-hx-mega-close]')) {
        if (section.contains(e.target.closest('[data-hx-mega-close]'))) {
          e.preventDefault();
          closeMenu(true);
          closeThemeDrawer();   // sluit ook de onderliggende theme-drawer
          return;
        }
      }
      var trig = isTriggerEl(e.target);
      if (trig) {
        e.preventDefault();
        e.stopPropagation();
        var li = trig.closest('.menu-list__list-item');
        if (li) {
          var exp = li.querySelector('[aria-expanded]');
          if (exp && exp !== trig) exp.setAttribute('aria-expanded', 'false');
        }
        clearTimeout(openTimer); clearTimeout(closeTimer);
        if (isOpen) closeMenu(true); else openMenu();
        return;
      }
      if (isOpen && !section.contains(e.target)) closeMenu(false);
    }, true);

    // ── TOETSENBORD ──
    document.addEventListener('keydown', function(e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { closeMenu(true); return; }
      if (e.key === 'Tab') {
        var f = focusableInPanel();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // ── RESIZE ──
    var rzTimer = null;
    window.addEventListener('resize', function() {
      clearTimeout(rzTimer);
      rzTimer = setTimeout(function() {
        if (isOpen) {
          var top = getHeaderBottom();
          if (panel) panel.style.top = top;
          var ov = section.querySelector('.hx-mega-overlay');
          if (ov) ov.style.top = top;
          lockScroll(true);
        }
      }, 150);
    }, { passive: true });
  }

  function initAll() {
    var sections = document.querySelectorAll('.hx-mega[data-hx-mega-id]');
    for (var i = 0; i < sections.length; i++) initHxMega(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      if (e.detail && e.detail.sectionId) {
        var s = document.querySelector('[data-hx-mega-id="' + e.detail.sectionId + '"]');
        if (s) { s.dataset.hxMegaInit = ''; initHxMega(s); }
      }
    });
  }
})();
